module.exports = __webpack_public_path__ + "static/Salesforce-31fcf8e3e8a3ee66e68e79c8ca864cf5.jpg";